import af from "@/plugins/vuetify/locales/af";
import en from "@/plugins/vuetify/locales/en";

const locales = {
    af: af,
    en: en
}

export default locales